var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1781_7910",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.5C0 11.6929 11.1929 0.5 25 0.5C38.8071 0.5 50 11.6929 50 25.5C50 39.3071 38.8071 50.5 25 50.5C11.1929 50.5 0 39.3071 0 25.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H50H0ZM50 50.5H0H50ZM0 50.5V0.5V50.5ZM26 0.5C39.8071 0.5 51 11.6929 51 25.5C51 39.3071 39.8071 50.5 26 50.5H25C38.2548 50.5 49 39.3071 49 25.5C49 11.6929 38.2548 0.5 25 0.5H26Z",
    fill: "white",
    mask: "url(#path-1-inside-1_1781_7910)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 14.125H21.75C20.8525 14.125 20.125 14.8525 20.125 15.75V35.25C20.125 36.1475 20.8525 36.875 21.75 36.875H34.75C35.6475 36.875 36.375 36.1475 36.375 35.25V15.75C36.375 14.8525 35.6475 14.125 34.75 14.125Z",
    fill: "#1066B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.75 14.125H21.75C20.8525 14.125 20.125 14.8525 20.125 15.75V35.25C20.125 36.1475 20.8525 36.875 21.75 36.875H34.75C35.6475 36.875 36.375 36.1475 36.375 35.25V15.75C36.375 14.8525 35.6475 14.125 34.75 14.125Z",
    fill: "url(#paint0_linear_1781_7910)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 16.5625H20.125V24.6875H28.25V16.5625Z",
    fill: "#32A9E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 24.6875H20.125V32.8125H28.25V24.6875Z",
    fill: "#167EB4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 24.6875H28.25V32.8125H36.375V24.6875Z",
    fill: "#32A9E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.375 16.5625H28.25V24.6875H36.375V16.5625Z",
    fill: "#58D9FD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1781_7910",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 23,
    width: 20,
    height: 14
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.875H36.375C37.2725 23.875 38 24.6025 38 25.5V35.25C38 36.1475 37.2725 36.875 36.375 36.875H20.125C19.2275 36.875 18.5 36.1475 18.5 35.25V23.875Z",
    fill: "url(#paint1_linear_1781_7910)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1781_7910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 23.875V27.125H36.375V23.875H38Z",
    fill: "#135298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 36.875V25.5L17.6875 36.875H38Z",
    fill: "url(#paint2_linear_1781_7910)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 36.875V25.5L38.8125 36.875H18.5Z",
    fill: "url(#paint3_linear_1781_7910)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.25C18.5 20.9038 19.5913 19.8125 20.9375 19.8125H25.8125C27.1587 19.8125 28.25 20.9038 28.25 22.25V32C28.25 33.3462 27.1587 34.4375 25.8125 34.4375H18.5V22.25Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.1875H13.625C12.7275 18.1875 12 18.915 12 19.8125V31.1875C12 32.085 12.7275 32.8125 13.625 32.8125H25C25.8975 32.8125 26.625 32.085 26.625 31.1875V19.8125C26.625 18.915 25.8975 18.1875 25 18.1875Z",
    fill: "url(#paint4_linear_1781_7910)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 25.5563V25.4212C23.375 23.0805 21.6908 21.4375 19.3254 21.4375C16.947 21.4375 15.25 23.0918 15.25 25.4437V25.5788C15.25 27.9195 16.9341 29.5625 19.3125 29.5625C21.678 29.5625 23.375 27.9082 23.375 25.5563ZM21.4594 25.5788C21.4594 27.1317 20.5853 28.0658 19.3254 28.0658C18.0655 28.0658 17.1784 27.1092 17.1784 25.5563V25.4212C17.1784 23.8683 18.0526 22.9342 19.3125 22.9342C20.5595 22.9342 21.4594 23.8908 21.4594 25.4437V25.5788Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1781_7910",
    x1: 20.125,
    y1: 25.5,
    x2: 36.375,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1781_7910",
    x1: 18.5,
    y1: 34.25,
    x2: 38,
    y2: 34.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B366F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2657B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1781_7910",
    x1: 38,
    y1: 31.1875,
    x2: 18.5,
    y2: 31.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44DCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#259ED0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1781_7910",
    x1: 18.5,
    y1: 31.1875,
    x2: 38,
    y2: 31.1875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#259ED0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44DCFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1781_7910",
    x1: 12,
    y1: 25.5,
    x2: 26.625,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#064484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F65B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.22d50df819f9dfb6f2152cc388dd175c.svg";
export { ForwardRef as ReactComponent };